import APIService from 'services/APIService'

const api = APIService()

const ActionsAPI = {
  list: params => api.get('/actions', { params }),
  stats: params => api.get('/actions/stats', { params }),
  performance: params => api.get('/actions/performance', { params }),
  get: id => api.get(`/actions/${id}`),
  create: payload => api.post('/actions', payload),
  update: (id, payload) => api.patch(`/actions/${id}`, payload),
  convertToTask: (id, payload) => api.post(`/actions/${id}/convert-to-task`, payload),
  approve: id => api.post(`/actions/${id}/approve`),
  dismiss: (id, payload) => api.post(`/actions/${id}/dismiss`, payload),
  undismiss: id => api.post(`/actions/${id}/undismiss`),
  resolve: id => api.post(`/actions/${id}/resolve`),
  reopen: id => api.post(`/actions/${id}/reopen`),
  bulkDismiss: payload => api.post('/actions/bulk-dismiss', payload),
  bulkApprove: payload => api.post('/actions/bulk-approve', payload),
  cleanupPreview: params => api.get('/actions/suggestion-cleanup', { params }),
  cleanupRun: payload => api.post('/actions/suggestion-cleanup', payload),
  cleanupUndo: batchId => api.post(`/actions/suggestion-cleanup/${batchId}/undo`),
  bulkConvert: payload => api.post('/actions/bulk-convert', payload),
  bulkUpdate: payload => api.post('/actions/bulk-update', payload),
  extractFromFile: fileId => api.post(`/building-passport/files/${fileId}/extract-actions`),
  extractionStatus: fileId => api.get(`/building-passport/files/${fileId}/extraction-status`),
  listComments: id => api.get(`/actions/${id}/comments`),
  createComment: (id, body) => api.post(`/actions/${id}/comments`, { body }),
  listActivities: id => api.get(`/actions/${id}/activities`),
}

export default ActionsAPI
